import axios from "../../../services/axios-config";

export async function getCompanyLogins({ companyId }) {
  const response = await axios.get("/admin/companies/logins", {
    params: { companyId },
  });

  return response?.data?.logins || [];
}
